import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { db } from '../../firebase'
import CommonHeader from "../../sub-components/CommonHeader"
import Footer from '../../sub-components/Footer'
import Orders from './Orders'
import Avatar from '@mui/material/Avatar';
import FavMenus from './FavMenus'
import FavRes from './FavRes'
import ProfileEdit from './ProfileEdit'
function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
  };
}


function Myprofile() {
  const {uid} = useParams()
  const [currentUser, setCurrentUser] = useState()
  useEffect(() => {
    db.collection('users').doc(`${uid}`).onSnapshot((doc) => {
      setCurrentUser(doc.data());
    });
}, [])
var phone1 = currentUser?.phoneNumber
const [firstName, setFirstName] = useState(currentUser?.firstName)
const [lastName, setLastName] = useState(currentUser?.lastName)
const [phone, setPhone] = useState(`${phone1}`)
  return (
    <div>
            <div className="modal fade" id="edit-profile-modal" tabIndex={-1} role="dialog" aria-labelledby="edit-profile" aria-hidden="true">
      <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="edit-profile">Edit profile</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
         <ProfileEdit firstName={currentUser?.firstName} lastName={currentUser?.lastName} phoneNumber={currentUser?.phoneNumber}/>
          </div>
          
          <div className="modal-footer">
          <button type="button"  className="btn d-flex w-50 text-center justify-content-center btn-outline-primary" data-dismiss="modal">CANCEL
            </button>          </div>
        </div>
      </div>
    </div>



        <CommonHeader />


        <section  className="section pt-4 pb-4 osahan-account-page">
      <div style={{marginTop:80}} className="container">
        <div className="row">
          <div className="col-md-3">
            <div className="osahan-account-page-left shadow-sm rounded bg-white ">
              <div className="border-bottom p-4">
                <div className="osahan-user text-center">
                  <div className="osahan-user-media">
                    {/* {phone} */}
                    <center>
                    <Avatar className="mb-3 rounded-pill shadow-sm mt-1" {...stringAvatar(`${currentUser?.firstName} ${currentUser?.lastName}`)} alt={`${currentUser?.firstName}`}/>
                    </center>
                    {/* <img className="mb-3 rounded-pill shadow-sm mt-1" src="img/user/4.png" alt="gurdeep singh osahan" /> */}
                    <div className="osahan-user-media-body">
                      <h6 className="mb-2">{currentUser?.firstName} {currentUser?.lastName}</h6>
                      <p className="mb-1">{currentUser?.phoneNumber}</p>
                      <p><a href="https://askbootstrap.com/cdn-cgi/l/email-protection" className="__cf_email__" data-cfemail="6a030b0705190b020b042a0d070b030644090507">{currentUser?.email}</a></p>
                      {/* <p className="mb-0 text-black font-weight-bold"><a className="text-primary mr-3" data-toggle="modal" data-target="#edit-profile-modal" href="#"><i className="icofont-ui-edit" /> EDIT</a></p> */}
                    </div>
                  </div>
                </div>
              </div>
              <ul className="nav nav-tabs flex-column border-0 pt-4 pl-4 pb-4" id="myTab" role="tablist">
                <li className="nav-item">
                  <a className="nav-link active" id="orders-tab" data-toggle="tab" href="#orders" role="tab" aria-controls="orders" aria-selected="true"><i className="icofont-food-cart" /> Orders</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" id="offers-tab" data-toggle="tab" href="#offers" role="tab" aria-controls="offers" aria-selected="false"><i className="icofont-heart" /> Favourites Menus</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" id="favourites-tab" data-toggle="tab" href="#favourites" role="tab" aria-controls="favourites" aria-selected="false"><i className="icofont-heart" /> Favourites Rest..</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-9">
            <div className="osahan-account-page-right rounded shadow-sm bg-white p-4 ">
              <div className="tab-content" id="myTabContent">
                <div className="tab-pane fade show active" id="orders" role="tabpanel" aria-labelledby="orders-tab">
                  <h4 className="font-weight-bold mt-0 mb-4">Past Orders</h4>
                     <Orders uid={uid}/>

                </div>
                <div className="tab-pane fade" id="offers" role="tabpanel" aria-labelledby="offers-tab">
                  <h4 className="font-weight-bold mt-0 mb-4">My Favourite Menus</h4>
                      <FavMenus uid={uid}/>
                </div>
                <div className="tab-pane fade" id="favourites" role="tabpanel" aria-labelledby="favourites-tab">
                  <h4 className="font-weight-bold mt-0 mb-4">Favourites Restaurants</h4>
                      <FavRes uid={uid} />
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>
    </section>



        <Footer />
    </div>
  )
}

export default Myprofile